import { NgModule } from '@angular/core';
import { Routes, ROUTES, RouterModule } from '@angular/router';

// Components
import { HotelLayoutOneComponent } from './hotel-layout-one/hotel-layout-one.component';
import { HotelLayoutTwoComponent } from './hotel-layout-two/hotel-layout-two.component';

// Services
import { TenantService } from './../shared/services/tenent.service';

@NgModule({
  imports: [RouterModule.forChild([])],
  exports: [RouterModule],
  providers: [
    {
      provide: ROUTES,
      useFactory: (tenantService: TenantService) => {
        let routes: Routes = [];
        const tenent = tenantService.getTenant();

        if (tenent && tenent['template'] === 'one') {
          routes.push({ path: '', component: HotelLayoutOneComponent, pathMatch: 'full' });
        }
        else if(tenent['template'] == 'two') {
          routes.push({ path: '', component: HotelLayoutTwoComponent, pathMatch: 'full' });
        }

        return [...routes];
      },
      multi: true,
      deps: [TenantService]
    }
  ]
})
export class HomeLayoutRoutingModule { }
